// @ts-ignore
import { AuthTypeEnum, DUMMY_BASE_URL, setSearchParams } from '@redhat-cloud-services/javascript-clients-shared/dist/common';
/**
  * @export
  * @enum {string}
  */
export const GetPrincipalAccessOrderByEnum = {
    Application: 'application',
    ResourceType: 'resource_type',
    Verb: 'verb'
};
/**
  * @export
  * @enum {string}
  */
export const GetPrincipalAccessStatusEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled',
    All: 'all'
};
const isGetPrincipalAccessObjectParams = (params) => {
    const l = params.length === 1;
    if (l && typeof params[0] === 'object' && !Array.isArray(params[0])) {
        return true && Object.prototype.hasOwnProperty.call(params[0], 'application');
    }
    return false;
};
/**
* Access responses are sorted in ascending order by an ID internal to the database
* @summary Get the permitted access for a principal in the tenant (defaults to principal from the identity header)
* @param {GetPrincipalAccessParams} config with all available params.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export const getPrincipalAccessParamCreator = async (sendRequest, ...config) => {
    const params = isGetPrincipalAccessObjectParams(config) ? config[0] : ['application', 'username', 'orderBy', 'status', 'limit', 'offset', 'options'].reduce((acc, curr, index) => ({ ...acc, [curr]: config[index] }), {});
    const { application, username, orderBy, status, limit, offset, options = {} } = params;
    const localVarPath = `/access/`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    const localVarRequestOptions = { method: 'GET', ...options };
    const localVarHeaderParameter = {};
    const localVarQueryParameter = {};
    if (application !== undefined) {
        localVarQueryParameter['application'] = application;
    }
    if (username !== undefined) {
        localVarQueryParameter['username'] = username;
    }
    if (orderBy !== undefined) {
        localVarQueryParameter['order_by'] = orderBy;
    }
    if (status !== undefined) {
        localVarQueryParameter['status'] = status;
    }
    if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
    }
    if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
    }
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
    const args = {
        urlObj: localVarUrlObj,
        options: localVarRequestOptions,
        auth: [
            {
                // authentication basic_auth required
                // http basic authentication required
                authType: AuthTypeEnum.Basic,
            }
        ]
    };
    return sendRequest(Promise.resolve(args));
};
export default getPrincipalAccessParamCreator;
//# sourceMappingURL=index.js.map